import React from 'react'

import { Form, Col } from '_zari/core'

import * as AuthService from 'services/auth.service'

const SedeFormGroup = ({ sedes, setSedes, sedeSeleccionada, setSedeSeleccionada }) => {
  React.useEffect(() => {
    AuthService.getSedesHabilitadas().then(({ data }) => {
      setSedes(data)
    })
  }, [setSedes])

  return (
    <Form.Group>
      <Form.Label text='ESTABLECIMIENTO' md={3} />
      <Col md={6}>
        <Form.Select id='select-sede' value={sedeSeleccionada} onChange={e => setSedeSeleccionada(e.target.value)}>
          <option value=''>Seleccionar</option>
          {sedes.map(x => (
            <option key={x._id} value={x._id}>
              {x.nombre}
            </option>
          ))}
        </Form.Select>
      </Col>
    </Form.Group>
  )
}

export default React.memo(SedeFormGroup)
